import { useModuleBEM } from "@b2bportal/core-themes";
import { typedKeys } from "@b2bportal/core-utilities";
import { useFilterSpecification } from "@tenant/cars";
import { CheckboxGroup } from "@tenant/ui";
import defaultStyles from "./FilterSpecification.module.scss";
import { useCarsStyles } from "~core-cars/themes";
import { CoreCarsComponent, type Specification } from "~core-cars/types";

export type FilterSpecificationProps = {
  selectedValues: Specification;
  onChange: (values: Specification) => void;
};

const COMPONENT_KEY = CoreCarsComponent.FilterSpecification;

export const FilterSpecification = (props: FilterSpecificationProps) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { items, onChange, selectedValues } = useFilterSpecification(props);

  return (
    <div className={block}>
      <CheckboxGroup
        className={cn("checkbox-group")}
        options={items}
        checkedOptions={typedKeys(selectedValues).filter(
          (key) => selectedValues[key]
        )}
        onOptionsChange={(selected: string[]) => {
          const initial = Object.fromEntries(
            typedKeys(selectedValues).map((key) => [key, false])
          ) as Specification;
          const selectedSpecifications = selected.reduce(
            (specifications, selectedOption) => {
              specifications[selectedOption] = true;
              return specifications;
            },
            initial
          );

          onChange(selectedSpecifications);
        }}
      />
    </div>
  );
};
